import { render, staticRenderFns } from "./financeSubmenu.vue?vue&type=template&id=965407b8&"
import script from "./financeSubmenu.vue?vue&type=script&lang=ts&"
export * from "./financeSubmenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports